<template>
  <div class="gmf-customer-attribute-pills" v-if="hasVisibleAttributes" :style="{ height: height ? height + 'px' : 'auto' }" v-on-resize="handleResize">
    <template v-for="(value, name) in visibleAttributes">
      <!--<b>{{ t('customer_attributes.' + name + '.title') || name }}: </b>-->
      <template v-if="Array.isArray(value)">
        <div class="gmf-customer-attribute-pills-pill" v-for="(v,index) in value" :key="name+'-'+index" ref="pills">
          {{ t('customer_attributes.' + name + '.values.' + v) || v }}
        </div>
      </template>
      <!--<div v-else-if="typeMap[name] && typeMap[name].type === 'multilineString'" class="gmf-customer-attribute-pills-pill" v-text="value" style="white-space: pre-wrap" :key="name+'multilineString'"></div>-->
      <div v-else-if="value" class="gmf-customer-attribute-pills-pill" :key="name+'general'" ref="pills">{{ t('customer_attributes.' + name + '.values.' + value) || value }}</div>
    </template>
  </div>
</template>

<style>
.gmf-context .gmf-customer-attribute-pills {
  display: flex;
  gap: var(--gmf-p-2);
  width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
}
.gmf-context .gmf-customer-attribute-pills-pill {
  background: var(--gmf-attribute-pill-bg);
  color: var(--gmf-attribute-pill-col);

  border-radius: 8px;
  padding: 0px var(--gmf-p-2);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  max-width: 100%;
  font-weight: bold;
  font-size: var(--gmf-text-small-font-size);
  flex-shrink: 0;
}
</style>

<script>
import getCustomerAttributeTypes from '@/utils/getCustomerAttributeTypes';
import state from '@/state';
import onResize from '@/directives/onResize';

export default {
  directives: {
    onResize
  },
  props: ['attributes', 'location', 'maxLines'],
  data () {
    return {
      types: [],
      height: null,
    };
  },
  methods: {
    t: state.t,
    handleResize() {
      // We need to calculate height when the element is resized
      // because there might be media queries that change the height of the pills
      this.$nextTick(this.calculateHeight);
    },
    calculateHeight() {
      // Reset height if no maxLines specified
      if (!this.maxLines || !this.$refs.pills?.length) {
        this.height = null;
        return;
      }
      const pills = this.$refs.pills;
      // Handle single line case
      if (this.maxLines === 1) {
        this.height = pills[0].offsetHeight;
        return;
      }

      // Calculate height for multiple lines
      let lines = 1;
      let lastY = pills[0].offsetTop;

      for (const pill of pills.slice(1)) {
        if (pill.offsetTop > lastY) {
          lines++;
          lastY = pill.offsetTop;

          // If we've exceeded the maxLines, set the height to the height of the previous pill + the y distance to the first pill
          if (lines > this.maxLines) {
            const prevPill = pills[pills.indexOf(pill) - 1];
            this.height = prevPill.offsetHeight + (prevPill.offsetTop - pills[0].offsetTop);
            return;
          }
        }
      }

      // No overflow occurred
      this.height = null;
    },
  },
  computed: {
    hasVisibleAttributes () {
      return Object.keys(this.visibleAttributes).length > 0;
    },
    visibleAttributes () {
      const visibleAttributes = {};
      for (const name in this.attributes) {
        const type = this.typeMap[name];
        if (! type || ! type.isPublic) {
          continue;
        }
        if (this.location === 'compactProfileCard' && ! type.showOnCompactProfileCard) {
          continue;
        }
        if (this.location === 'comment' && ! type.showOnComments) {
          continue;
        }
        visibleAttributes[name] = this.attributes[name];
      }
      return visibleAttributes;
    },
    typeMap () {
      const map = [];
      for (const t of this.types) {
        map[t.name] = t;
      }
      return map;
    },
  },
  async mounted () {
    this.types = await getCustomerAttributeTypes();
    this.$nextTick(this.calculateHeight);
  },

  watch: {
    maxLines() {
      this.$nextTick(this.calculateHeight);
    },
    visibleAttributes() {
      this.$nextTick(this.calculateHeight);
    },
  },
};

</script>
